import { createContext } from 'react'

const user = createContext()

export default user
